import { Pipe, PipeTransform } from '@angular/core';

import { dtgOfSelectedTimestep } from '../constants/constants';

@Pipe({ name: 'dtgOfSelectedTimestep' })
export class DtgOfSelectedTimestepPipe implements PipeTransform {
  transform(selectedTime: number, mapsTime) {
    return dtgOfSelectedTimestep(selectedTime, mapsTime);
  }
}
